import styles from "./NotificationSkeleton.module.css";

export default function NotificationSkeleton() {
  return (
    <div className={styles.skeleton}>
      <div className={styles.icon}></div>
      <div className={styles.content}>
        <div className={styles.message}></div>
        <div className={styles.metadata}>
          <div className={styles.avatar}></div>
          <div className={styles.name}></div>
        </div>
        <div className={styles.timestamp}></div>
      </div>
    </div>
  );
}
